import React from "react";
import { Route } from "react-router-dom";
import AdminPanelScreen from "../screens/admin/AdminPanelScreen";
import ManageUsersScreen from "../screens/admin/ManageUsersScreen";
import ManagePlanScreen from "../screens/admin/ManagePlanScreen";
import StatisticsScreen from "../screens/admin/StatisticsScreen";
import MaintenanceScreen from "../screens/admin/MaintenanceScreen";
import AdminAnnouncementsPage from "../Admin/notifications/AdminAnnouncement";
import NotificationsPage from "../screens/user/NotificationScreen";
import FreeTrail from "../Admin/free-trail/FreeTrail";
import CampaignRenewals from "../Admin/campaign-renewals/CampaignRenewals";
import FailedPosts from "../Admin/failed-posts/FailedPosts";
import WeeklySummary from "../Admin/weekly-summary/WeeklySummary";
import AppConfig from "../Admin/app-config/AppConfig";
import AccountHealth from "../Admin/account-health/AccountHealth";
import ListingSync from "../Admin/listing-sync/ListingSync";
import UserQuota from "../Admin/user-quota/UserQuota";
import SocialConnections from "../Admin/social-connections/SocialConnections";
import CaptionViolations from "../Admin/caption-violations/CaptionViolations";
import CommercialAutoVideo from "../Admin/commercial-auto-video/CommercialAutoVideo";
import Brokerages from "../Admin/masters/Brokerages";

const adminRoutes = (
    <>
        <Route path="/admin" element={<AdminPanelScreen />} />
        <Route path="/admin/manage-users" element={<ManageUsersScreen />} />
        <Route path="/admin/manage-plans" element={<ManagePlanScreen />} />
        <Route path="/admin/statistics" element={<StatisticsScreen />} />
        <Route path="/admin/maintenance" element={<MaintenanceScreen />} />
        <Route
            path="/admin/announcements"
            element={<AdminAnnouncementsPage />}
        />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/admin/free-trial" element={<FreeTrail />} />
        <Route path="/admin/campaign-renewals" element={<CampaignRenewals />} />
        <Route path="/admin/failed-posts" element={<FailedPosts />} />
        <Route path="/admin/weekly-summary" element={<WeeklySummary />} />
        <Route path="/admin/app-config" element={<AppConfig />} />
        <Route path="/admin/account-health" element={<AccountHealth />} />
        <Route path="/admin/listing-sync" element={<ListingSync />} />
        <Route path="/admin/user-quota" element={<UserQuota />} />
        <Route
            path="/admin/social-connections"
            element={<SocialConnections />}
        />
        <Route
            path="/admin/caption-violations"
            element={<CaptionViolations />}
        />
        <Route
            path="/admin/commercial-auto-video"
            element={<CommercialAutoVideo />}
        />
        <Route path="/admin/masters/brokerages" element={<Brokerages />} />
        <Route path="*" element={<AdminPanelScreen />} />
    </>
);

export default adminRoutes;
